import { createAction, createReducer } from "@reduxjs/toolkit";
import { createPopupBanner, deletePopupBanner, editPopUpBanner, getAllPopupBanner } from "./addPopupBanner.action";

type loadingCondition = "idle" | "pending" | "fulfilled" | "rejected";

export type IPopupBanners = {
  allPopupBanners: {
    data: any[];
  };
  loading?: string;
  itemToBeEdit: {
    item: any;
    isEdit?: boolean;
    currentPage?: number;
  };
  itemToBeDelete: {
    currentPage: number;
  };
  deleteLoading?: loadingCondition;
};

const intialState: IPopupBanners = {
  allPopupBanners: {
    data: [],
  },
  loading: "idle",
  itemToBeEdit: {
    item: {},
    isEdit: false,
    currentPage: 0,
  },
  itemToBeDelete: {
    currentPage: 0,
  },
  deleteLoading: "idle",
};

export const editPopupBannerItem = createAction("edit-ad-item", (itemToBeEdit) => {
  return {
    payload: itemToBeEdit,
  };
});

export const resetEditPopupBannerItem = createAction(
  "reset-edit-ad-item",
  (itemToBeEdit) => {
    return {
      payload: itemToBeEdit,
    };
  }
);

export const popupBannerReducer = createReducer(intialState, (bulider) => {
  // create ad
  bulider.addCase(createPopupBanner.pending, (state, action) => {
    state.loading = "pending";
  });
  bulider.addCase(createPopupBanner.fulfilled, (state, action) => {
    state.allPopupBanners.data = [
      action.payload,
      ...state.allPopupBanners.data,
    ];
    state.loading = "fulfilled";
  });
  bulider.addCase(createPopupBanner.rejected, (state, action) => {
    state.loading = "rejected";
  });

  // get all add
  bulider.addCase(getAllPopupBanner.pending, (state, action) => {
    state.loading = "pending";
  });
  bulider.addCase(getAllPopupBanner.fulfilled, (state, action) => {
    if (action.payload) {
      state.allPopupBanners.data = action.payload;
    }
    state.loading = "fulfilled";
  });
  bulider.addCase(getAllPopupBanner.rejected, (state, action) => {
    state.loading = "rejected";
  });


    // Making Item to Readble on other side
    bulider.addCase(editPopupBannerItem, (state, action) => {
      state.itemToBeEdit = action.payload;
    });
    // reseting the EditState
    bulider.addCase(resetEditPopupBannerItem, (state, action) => {
      state.itemToBeEdit = intialState.itemToBeEdit;
    });

    // edit item
    bulider.addCase(editPopUpBanner.pending, (state, action) => {
      state.loading = "pending";
    });
    bulider.addCase(editPopUpBanner.fulfilled, (state, action) => {
      const temp = [...state.allPopupBanners.data];
      const id = action.payload._id;
      temp.forEach((item: any, index) => {
        if (item?._id === id) {
          temp[index] = action.payload;
        }
      });
      state.allPopupBanners.data = temp;
      state.loading = "fulfilled";
    });
    bulider.addCase(editPopUpBanner.rejected, (state, action) => {
      state.loading = "rejected";
    });

    // delete ad
    bulider.addCase(deletePopupBanner.pending, (state, action) => {
      state.deleteLoading = "pending";
    });
    bulider.addCase(deletePopupBanner.fulfilled, (state, action) => {
      const temp = [...state.allPopupBanners.data];
      const id = action.payload && action.payload._id;
      temp.forEach((item: any, index) => {
        if (item?._id === id) {
          temp.splice(index, 1);
        }
      });
      state.allPopupBanners.data = temp;
      state.deleteLoading = "fulfilled";
    });
    bulider.addCase(deletePopupBanner.rejected, (state, action) => {
      state.deleteLoading = "rejected";
    });
});
